import { render, staticRenderFns } from "./DeleteButtonCustom.vue?vue&type=template&id=279f0eba"
import script from "./DeleteButtonCustom.vue?vue&type=script&lang=js"
export * from "./DeleteButtonCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports